import { useLensProcessStore } from '@/app/[variants]/_lens-components/store/lens-process-store';
import { getApiPrescriptionType } from '@/app/[variants]/_lens-components/utils';
import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';

export default function useTrackEditPrescription() {
  const { trackEvent } = useReporting();
  const { lensGoodsSensorsData, prescriptionType, presTypeOptionName } = useLensProcessStore();

  const baseProperties = {
    ...(lensGoodsSensorsData || {}),
    prescription_type_name: presTypeOptionName,
    prescription_type: getApiPrescriptionType(prescriptionType),
  };
  // 选择处方方式页面浏览
  function trackPrescriptionMethodsView() {
    trackEvent(
      {
        eventName: 'PrescriptionEnterTypeChoosePage_View',
        properties: baseProperties,
      },
      [ProviderType.SENSORS],
    );
  }
  // 选择处方填写方式页面点击
  function trackPrescriptionMethodsSelect(prescription_enter_type: string) {
    trackEvent(
      {
        eventName: 'PrescriptionEnterTypeChoosePage_EnterType_Click',
        properties: {
          ...baseProperties,
          prescription_enter_type,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 已保存处方页面浏览
  function trackSavedPrescriptionsView() {
    trackEvent(
      {
        eventName: 'PrescriptionSaveChoosePage_View',
        properties: {
          ...baseProperties,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 已保存处方页面点击
  function trackClickSavedPrescription(properties: {
    save_prescription_name: string;
    check_way: 'Checked' | 'Cancel';
  }) {
    trackEvent(
      {
        eventName: 'PrescriptionSaveChoosePage_Choose_Click',
        properties: {
          ...baseProperties,
          ...properties,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 编辑已保存处方页面
  function trackEditSavedPrescription(save_prescription_name: string) {
    trackEvent(
      {
        eventName: 'PrescriptionSaveChoosePage_Edit_Click',
        properties: {
          ...baseProperties,
          save_prescription_name,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 提交已保存的处方页面
  function trackSubmitSavedPrescription(save_prescription_name: string, btn_name: string) {
    trackEvent(
      {
        eventName: 'PrescriptionSaveChoosePage_Submit_Click',
        properties: {
          ...baseProperties,
          save_prescription_name,
          btn_name,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 纠错弹窗曝光
  function trackExposeCorrectionDialog() {
    trackEvent(
      {
        eventName: 'PrescriptionEnterPage_PopupRevise_Exp',
        properties: baseProperties,
      },
      [ProviderType.SENSORS],
    );
  }
  // * 纠错弹窗点击
  function trackClickCorrectionDialog(btn_name: string) {
    trackEvent(
      {
        eventName: 'PrescriptionEnterPage_PopupRevise_Click',
        properties: {
          ...baseProperties,
          btn_name,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 处方扫描指导页浏览
  function trackScanGuidePageView() {
    trackEvent(
      {
        eventName: 'PrescriptionScanGuidePage_View',
        properties: baseProperties,
      },
      [ProviderType.SENSORS],
    );
  }
  // * 处方扫描指导页上传
  function trackScanGuidePageUpload(btn_name: string) {
    trackEvent(
      {
        eventName: 'PrescriptionScanGuidePage_Upload_Click',
        properties: {
          ...baseProperties,
          btn_name,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  function trackFillOutPrescriptionMainView() {
    trackEvent(
      {
        eventName: 'PrescriptionEnterPage_View',
        properties: {
          ...baseProperties,
          is_magnification_page: false,
          is_have_scan_prescription: false,
        },
      },
      [ProviderType.SENSORS],
    );
  }
  // * 处方参数介绍弹窗
  function trackIntroduceParam(param_introduction_type) {
    try {
      trackEvent(
        {
          eventName: 'PrescriptionEnterPage_ParamIntroduction_Click',
          properties: {
            ...baseProperties,
            is_magnification_page: false,
            param_introduction_type,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.error('👀', e);
    }
  }
  function trackParamValueClick(param_value_type: string) {
    try {
      trackEvent(
        {
          eventName: 'PrescriptionEnterPage_ParamValue_Click',
          properties: {
            ...baseProperties,
            is_magnification_page: false,
            param_value_type,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.error('👀', e);
    }
  }
  function trackFillPrescriptionCheckClick(check_type: string, check_way: 'Checked' | 'Cancel') {
    try {
      trackEvent(
        {
          eventName: 'PrescriptionEnterPage_Check_Click',
          properties: {
            ...baseProperties,
            check_type,
            check_way,
          },
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.error('👀', e);
    }
  }
  return {
    trackPrescriptionMethodsSelect,
    trackPrescriptionMethodsView,
    trackSavedPrescriptionsView,
    trackClickSavedPrescription,
    trackEditSavedPrescription,
    trackSubmitSavedPrescription,
    trackExposeCorrectionDialog,
    trackClickCorrectionDialog,
    trackScanGuidePageView,
    trackScanGuidePageUpload,
    trackFillOutPrescriptionMainView,
    trackIntroduceParam,
    trackParamValueClick,
    trackFillPrescriptionCheckClick,
  };
}
